// export const apiBaseURL = 'http://192.168.0.10:8000/api';
// export const apiBaseURL = process.env.NODE_ENV === 'development'
//   ? 'http://192.168.0.10:8000/api'
//   : 'https://sistema.drfumigaciones.com.ar/api';

// export const frontendURL = process.env.NODE_ENV === 'development'
//   ? 'http://192.168.0.10:3000/app'
//   : 'https://sistema.drfumigaciones.com.ar/app';

export const apiBaseURL = `${process.env.REACT_APP_API_ENDPOINT}`;
export const frontendURL = `${process.env.REACT_APP_FRONTEND_URL}`;